import '../stylesheets/styles.scss';

// import 'jquery-migrate';

import 'core-js';

// import 'bootstrap';
import 'bootstrap/js/dist/util';
import 'bootstrap/js/dist/dropdown';
import 'bootstrap/js/dist/collapse';
import 'bootstrap/js/dist/modal';
import 'bootstrap/js/dist/scrollspy';
import 'bootstrap/js/dist/carousel';

import './utils/imagesConfig';
import 'lazysizes';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import 'lazysizes/plugins/respimg/ls.respimg';

import 'slick-carousel';

import 'overlayscrollbars/js/jquery.overlayScrollbars';
import 'overlayscrollbars/css/OverlayScrollbars.css';

import 'jquery';
import './libs/jquery.hasExtension';
// import './libs/jquery.mousewheel-3.0.6.min';
// import './libs/jquery.mCustomScrollbar.custom.min';
import './libs/relocate';

import { asyncSVG } from './libs/asyncSVG';

import './utils/tcl_cookieconsent';

import { PageData, Cookies, Keyboard, Logger, Responsive } from './utils'; // eslint-disable-line object-curly-newline
import { Brightcove } from './components/brightcove';
import { Header } from './components/header';
import { Search } from './components/search';
import { Footer } from './components/footer';
import { Hero } from './components/hero';
import { FullWidth } from './components/full-width';
import { Article } from './components/article';
import { Highlight } from './components/highlight';
import { Numbers } from './components/numbers';
import { Splitted } from './components/splitted';
import { Page } from './components/page';
import { LinkList } from './components/link-list';
import { Bookmark } from './components/bookmark';
import { CarouselTimeline } from './components/carousel-timeline';
import { Journal } from './components/journal';
import { Greetings } from './components/greetings';
import { Infografica } from './components/infografica';
import { Cookie } from './components/cookie';
import { DoubleCol } from './components/double-col';
import { Title } from './components/title';
import { ModalPopupShare } from './components/modal-popup-share';
import { CarouselQuote } from './components/carousel-quote';
import { Opere } from './components/opere';
import { News } from './components/news';
import { CenteredBlock } from './components/centered-block';
import { Text } from './components/text';
import { Mostra } from './components/mostra';
import { Attached } from './components/attached';
import { Download } from './components/download';
import { MenuSecondLevel } from './components/menu-second-level';
import { LegalPage } from './components/legal-page';
import { ChartTorta } from './components/chart-torta';
import { ChartTree } from './components/chart-tree';
import { ChartGovernance } from './components/chart-governance';
import { Tabella } from './components/tabella';
import { Sidemenu } from './components/sidemenu';
import { Multibloc } from './components/multibloc';

if (!('object-fit' in document.createElement('a').style)) {
  require('lazysizes/plugins/object-fit/ls.object-fit'); // eslint-disable-line global-require
}

// load asyncronoysly the SVG sprite and inject it inside the page
asyncSVG();

// initialize components
const Components = {
  brightcove: new Brightcove(),
  header: new Header(),
  search: new Search(),
  footer: new Footer(),
  hero: new Hero(),
  fullWidth: new FullWidth(),
  article: new Article(),
  highlight: new Highlight(),
  numbers: new Numbers(),
  splitted: new Splitted(),
  linkList: new LinkList(),
  bookmark: new Bookmark(),
  carouselTimeline: new CarouselTimeline(),
  journal: new Journal(),
  greetings: new Greetings(),
  infografica: new Infografica(),
  cookie: new Cookie(),
  doubleCol: new DoubleCol(),
  title: new Title(),
  modalPopupShare: new ModalPopupShare(),
  carouselQuote: new CarouselQuote(),
  opere: new Opere(),
  news: new News(),
  centeredBlock: new CenteredBlock(),
  text: new Text(),
  mostra: new Mostra(),
  attached: new Attached(),
  download: new Download(),
  menuSecondLevel: new MenuSecondLevel(),
  legalPage: new LegalPage(),
  chartTorta: new ChartTorta(),
  chartTree: new ChartTree(),
  chartGovernance: new ChartGovernance(),
  tabella: new Tabella(),
  sidemenu: new Sidemenu(),
  multibloc: new Multibloc(),
};

const PageInstance = new Page(); // must be initialized after the other components

export {
  PageInstance,
  Components,
  PageData,
  Cookies,
  Keyboard,
  Logger,
  Responsive,
};
